import vByline from "./v-byline.vue";

export default Vue => {
  Vue.component("v-byline", vByline);
};
